import styled, { createGlobalStyle } from 'styled-components';
import { color, fontSize, fontWeight, spacing } from 'theme';

export const GlobalStyles = createGlobalStyle`
  .ReactModal__Overlay {
    background-color: rgba(53,50,65,0.35) !important;
  }
`;

export const StyledWrapper = styled.div`
  width: 100%;
`;

export const StyledInfo = styled.div`
  background: ${color('midnight_100')};
  color: ${color('midnight_800')};
  font-size: ${fontSize('md')};
  padding: ${spacing('md')};
  margin-bottom: ${spacing('xl')};

  h5 {
    color: ${color('midnight_500')};
    font-size: ${fontSize('sm')};
    font-weight: ${fontWeight('extraBold')};
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: ${spacing('sm')};
  }

  li {
    list-style-type: disc;
    margin-left: 1rem;
  }
`;

export const StyledSubtitle = styled.h4`
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('extraBold')};
  margin-bottom: ${spacing('md')};
`;

export const StyledTerms = styled.ul`
  margin-bottom: ${spacing('lg')};

  li {
    list-style-type: disc;
    margin-left: 1rem;
    margin-bottom: ${spacing('xs')};
  }
`;
